import * as React from "react"
import * as Immutable from "immutable";

import { Theme } from "../../types/types";
import QuickFilter, { QuickFilterProps } from "../home/components/QuickFilter";
import { replaceWithJsx } from "../../utils/replace";
import { RentalAdvertSnippet } from "../shared/area_theme/RentalAdvertSnippet";
import { LinkListItems } from "../shared/area_theme/LinkListItems";


const humanizedGitesCount = (theme: Theme) : JSX.Element => (
  <a href={theme.giteOverviewPath}>
    {I18n.t(`themes.${theme.identifier}.count.gite`, { count: theme.gitesCount, area: theme.name } )}
  </a>
)

const humanizedBnbCount = (theme: Theme) : JSX.Element => (
  <a href={theme.bnbOverviewPath}>
    {I18n.t(`themes.${theme.identifier}.count.gite`, { count: theme.bedAndBreakfastsCount, area: theme.name } )}
  </a>
)

const humanizedCount = (theme: Theme) : JSX.Element => (
  theme.gitesCount > 0 && theme.bedAndBreakfastsCount > 0 ?
    replaceWithJsx(I18n.t("areas.count.both", { gites: '%gites%', bnb: '%bnb%' } ), Immutable.Map({
      gites: () => humanizedGitesCount(theme),
      bnb: () => humanizedBnbCount(theme),
    }))
  : theme.gitesCount > 0 ?
    replaceWithJsx(I18n.t("areas.count.single", { string: '%gites%' } ), Immutable.Map({
      gites: () => humanizedGitesCount(theme),
    }))
  : theme.bedAndBreakfastsCount > 0 ?
    replaceWithJsx(I18n.t("areas.count.single", { string: '%bnb%' } ), Immutable.Map({
      bnb: () => humanizedBnbCount(theme),
    }))
  : null
)


type Props = {
  theme: Theme
} & QuickFilterProps

export const Show = (props: Props) : JSX.Element => (
  <div>
    <div className="hero hero--theme">
      <div className="hero__visual" style={{backgroundImage: `url(${props.theme.headerImage.url})`}}>
        <img className="hero__image" src={props.theme.headerImage.url} />
      </div>
    </div>
    <div className="page-section page-section--yellow page-section--slim home-filters">
      <div className="grid-container home-filters__inner">
        <div className="grid-100 tac">
          <h1 className="page-section__title page-section__title--big">{props.theme.name}</h1>
          {humanizedCount(props.theme)}
          {
            props.theme.gitesCount > 0 ?
              <p>
                <a id="midi-pyrenees_area_top_cta_gite" className="btn btn--ghost-darkblue" href={props.theme.giteOverviewPath}>
                  {
                    I18n.t(
                      `themes.${props.theme.identifier}.count.accommodations`,
                      {
                        count: props.theme.gitesCount,
                        defaultValue: I18n.t('themes.view_accommodations', { count: props.theme.gitesCount })
                      }
                    )
                  }
                </a>
              </p>
            : ''
          }
        </div>
      </div>
    </div>
    <div className="page-section page-section--pt">
      <div className="grid-container">
        <div className="grid-50 suffix-25 push-25 tablet-grid-70 tablet-suffix-5 tablet-push-25">
          <h2 className="page-section__title">{props.theme.bodyTitle}</h2>
          {
            replaceWithJsx(
              props.theme.bodyContent,
              Immutable.Map({
                ADVERTS: () => (
                <div className="accommodations accommodations--area">
                  {
                    Immutable.List(props.theme.rentalAdverts.nodes).map(x => (
                      <RentalAdvertSnippet rental_advert={x} key={x.id} />
                    ))
                  }
                </div>
              )}),
              (s) => <>{require('html-react-parser')(s)}</>
            )
          }
          {
            props.theme.listTitle && props.theme.linkListItems ?
              <LinkListItems
                title={props.theme.listTitle}
                items={Immutable.List(props.theme.linkListItems)}
              />
            : ''
          }
        </div>
        <div className="grid-20 suffix-5 pull-75 tablet-grid-20 tablet-suffix-5 tablet-pull-75 hide-below-tablet-landscape">
          { props.theme.bodyImage && props.theme.bodyImage.exists ? <img className="fill-image" src={props.theme.bodyImage.url} /> : '' }
        </div>
      </div>
    </div>
  </div>
)
